import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatCheckboxChange, MatDialog, MatSnackBar, MatStepper, MatTableDataSource} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {RefrigeratorSelectionDialogComponent} from './refrigerator-selection-dialog/refrigerator-selection-dialog.component';
import {SelectionModel} from '@angular/cdk/collections';

interface Kind {
  id: number;
  name: string;
}

@Component({
  templateUrl: './repair-order-form.component.html',
  styleUrls: ['./repair-order-form.component.scss']
})
export class RepairOrderFormComponent implements OnInit {
  //#region Global declarations
  public dataSource: MatTableDataSource<any>;
  public selectedCategory: number;
  public selectedKind: Kind;
  public kinds: Kind[] = [];
  public representativesDisplayedColumns: string[];
  public representativesForm: FormGroup;
  public tableContainerHeight: any;
  public tableContainerWidth: any;
  public cardContainerHeight: any;
  public cardContainerWidth: any;
  public tableHeight: any;
  public selection: SelectionModel<any>;
  public isLoading: boolean;
  public damages: any;
  public minDate;
  public error: string;
  public scheduledDate;
  stepLoading = false;
  // tslint:disable-next-line:variable-name
  public special_damages: any;
  // tslint:disable-next-line:variable-name
  public refrigerator_types: any;
  // tslint:disable-next-line:variable-name
  public product_status: any;
  public refrigeratorType: any;
  public productStatus: any;
  public temperature: number;
  public comments: string;
  public serialNumber: string;
  public refrigeratorsToSubmit: any;
  public serialNumberError: boolean;
  public user: any;
  public userDataInitialized: boolean;
  validateSerialNumberLoading: boolean;
  existingRefrigerators: any;
  selectedRefrigerator: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  private filters: string[] = ['(category_id=2)', '(account_group_id=3000 OR account_group_id=3009)',
    '(account_group_id<>3000 AND account_group_id<>3009 AND sales_organization_id <> 3000)'];
  config: any = {
    filter: 'type_id=3'
  };

//#endregion

  constructor(public authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar) {
    this.userDataInitialized = false;
    this.representativesForm = new FormGroup({});
    this.selection = new SelectionModel<any>(true, []);
  }

  public async ngOnInit(): Promise<any> {
    await this.initUser();
    this.minDate = new Date();
    this.temperature = 0;
    this.dataSource = new MatTableDataSource<any>();
    this.selection = new SelectionModel<any>(true, []);
    this.cardContainerHeight = window.innerHeight - 200;
    this.cardContainerWidth = window.innerWidth - 310;
    this.tableContainerHeight = window.innerHeight - 350;
    this.tableContainerWidth = window.innerWidth - 310;
    this.tableHeight = this.tableContainerHeight - 150;
    this.representativesDisplayedColumns = ['select', 'customer_name', 'vat_number', 'city',
      'address', 'phone_number1', 'type_name', 'sales_group_id', 'sales_group_name', 'division_name'];
    this.representativesForm = new FormGroup({});
    this.refrigeratorsToSubmit = [];
    this.serialNumberError = false;
    this.validateSerialNumberLoading = false;
    await this.initKinds();
  }

  async initKinds() {
    try {
      this.kinds = await this.commonService.getSimpleList(`repair_kind`) as Kind[];
    } catch (e) {
    }
  }

  async initUser() {
    try {
      this.user = await this.authService.getUser();
      this.userDataInitialized = true;
    } catch (e) {
      this.userDataInitialized = false;
    }
  }


  //#region Pagination And Filter
  private initPaginatorAndSort() {
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //#endregion
  //#region Selection
  masterToggle() {
    return null;
  }

  selectRow(row: any) {
    this.selection.clear();
  }

  selectionChanged($event: MatCheckboxChange, row: any) {
    if ($event.checked === false) {
      return this.selection.deselect(row);
    } else {
      return this.selection.select(row);
    }
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    // @ts-ignore
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  //#endregion

  //#region Disables
  isFirstStepInvalid() {
    if (this.selection.selected.length > 0 && this.selectedKind) {
      return false;
    } else {
      return true;
    }
    // return this.selection.selected.length === 0 || !this.scheduledDate;
    // return this.selection.selected.length === 0 && !this.selectedKind;
  }

  isSecondStepInvalid() {
    return this.refrigeratorsToSubmit.length === 0;
  }

  displaySpecialDamages() {
    if (this.damages && this.damages.length > 0) {
      const damage = this.damages.find(d => d.id === 5);
      return damage.checked;
    } else {
      return false;
    }
  }

  canSave(): boolean {
    // let inValid = true;

    // tslint:disable-next-line:triple-equals
    if (this.selectedCategory == 0) {
      // return !this.serialNumber;
      return !(this.refrigeratorType && this.productStatus);
    } else {
      return !(this.refrigeratorType && this.productStatus);
    }

    // if (this.selectedCategory !== 0) {
    //   return !(this.serialNumber && this.refrigeratorType && this.productStatus);
    // }

    // return inValid;
    // const numberOfDamages = this.damages.filter(d => d.checked === true);
    //
    // return inValid && numberOfDamages.length === 0;
  }

  //#endregion

  //#region Stepper next & previous
  async next() {
    if (this.stepper.selectedIndex === 0) {
      try {
        this.stepLoading = true;
        this.damages = await this.commonService.getSimpleList(`repair/damages`);
        this.special_damages = await this.commonService.getSimpleList(`repair/special_damages`);
        this.refrigerator_types = await this.commonService.getSimpleList(`repair/refrigerator_type`);
        this.product_status = await this.commonService.getSimpleList(`repair/product_status`);
        this.existingRefrigerators = [];
        this.existingRefrigerators = await this.commonService.getListWithParameters(`refrigerator/refrigerator2`, `sale_point_id =${this.selection.selected[0].id}`);
        this.stepLoading = false;
        for (const damage of this.damages) {
          damage.checked = false;
        }

        for (const damage of this.special_damages) {
          damage.checked = false;
        }
      } catch (e) {
      } finally {
        this.stepper.next();
      }
    } else if (this.stepper.selectedIndex === 1) {
      this.stepper.next();
    }
  }

  previous() {
    this.stepper.previous();
  }

  //#endregion

  async categorySelected() {
    this.dataSource = new MatTableDataSource<any>();
    this.isLoading = true;
    try {
      await this.initDataSource(this.selectedCategory);
    } catch (e) {
    } finally {
      this.isLoading = false;
    }
  }

  private async initDataSource(selectedCategory: number) {
    const user = await this.authService.getUser();
    try {
      let filter = '';
      if (this.user.role_alternate_name === 'hqManager') {
        filter = `key_account_id IN (${this.user.hq_ids})`;
      } else {
        filter = this.filters[selectedCategory];
      }
      const result: any = await this.commonService.getListWithParameters('sale_point/for_repair', filter);
      this.dataSource = new MatTableDataSource<any>(result);
      this.initPaginatorAndSort();
    } catch (e) {
      throw e;
    }
  }


  //#region Saves and Submit
  async submit() {
    const model = {
      sale_point_id: this.selection.selected[0].id,
      kind_id: this.selectedKind.id,
      // expected_date: this.scheduledDate,
      details: this.refrigeratorsToSubmit,
      type_id: 3
    };

    try {
      this.stepLoading = true;
      await this.commonService.insertObject('repair/web', model);
    } catch (e) {
    } finally {
      this.stepLoading = false;
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις εντολές επισκευής',
          redirectURL: `repairs`
        }
      });
    }
  }

  async save() {
    let proceed = false;

    try {
      await this.validateRefrigerator();
      proceed = !this.serialNumberError;
    } catch (e) {
      proceed = false;
    }

    if (proceed) {
      if (this.serialNumber !== '') {
        const existing = this.refrigeratorsToSubmit.filter(refrigerator => refrigerator.serial_number === this.serialNumber);
        if (existing.length > 0) {
          this.openSnackBar(`Το ψυγείο με σειριακό αριθμό: ${this.serialNumber} υπάρχει ήδη στην λίστα`);
          return;
        }
      }

      const damages = this.damages.filter(d => d.checked === true);
      const submittedDamages = [];
      for (const damage of damages) {
        submittedDamages.push({id: damage.id});
      }

      const submittedSpecialDamages = [];
      const specialDamages = this.special_damages.filter(d => d.checked === true);
      for (const damage of specialDamages) {
        submittedSpecialDamages.push({id: damage.id});
      }
      const refrigeratorToSubmit = {
        serial_number: this.serialNumber,
        material_description: null,
        refrigerator_type_id: this.refrigeratorType ? this.refrigeratorType.id : null,
        product_status_id: this.productStatus ? this.productStatus.id : null,
        temperature: this.temperature,
        comments: this.comments,
        damages: submittedDamages,
        special_damages: submittedSpecialDamages,
        files: []
      };

      this.refrigeratorsToSubmit.push(refrigeratorToSubmit);
      this.openSnackBar('Το ψυγείο προστέθηκε με επιτυχία στην λίστα');
      this.clearForm();
    }
  }

  //#endregion


  //#region checkBoxes actions and snackBar

  openSnackBar(message: string) {
    const action = 'Κλείσιμο';
    this.matSnackBar.open(message, action, {
      duration: 2000,
    });
  }

  damageCheckedChange(damage: any) {
    damage.checked = !damage.checked;
  }

  specialDamageCheckedChange(damage: any) {
    damage.checked = !damage.checked;
  }

  //#endregion

  private clearForm() {
    // clear Damages and special Damages
    for (const damage of this.damages) {
      damage.checked = false;
    }

    for (const damage of this.special_damages) {
      damage.checked = false;
    }

    this.serialNumber = '';
    this.temperature = 0;
    this.productStatus = null;
    this.refrigeratorType = null;
    this.comments = '';
  }

  public isSerialNumberInputDisabled(): boolean {
    return this.validateSerialNumberLoading || (this.user && this.user.role_alternate_name === 'hqManager');
  }

  showRefrigeratorType(id: number) {
    const type = this.refrigerator_types.find(t => t.id === id);
    return type ? type.description : '';
  }

  showProductStatus(id: number) {
    const status = this.product_status.find(s => s.id === id);
    return status ? status.description : '';
  }

  removeFromList(index: number) {
    this.refrigeratorsToSubmit.splice(index, 1);
  }

  showDamages(damages: any) {
    let description = '';
    for (const d of damages) {
      const damage = this.damages.find(x => x.id === d.id);
      description += `${damage.description},`;
    }
    return description;
  }

  // tslint:disable-next-line:variable-name
  showSpecialDamages(special_damages: any) {
    let description = '';
    for (const d of special_damages) {
      const damage = this.special_damages.find(x => x.id === d.id);
      description += `${damage.description},`;
    }
    return description;
  }

  isThirdStepInvalid() {
    return this.refrigeratorsToSubmit.length === 0;
  }

  async validateRefrigerator() {
    this.validateSerialNumberLoading = true;
    const salePointId = this.selection.selected[0].id;
    let existingRefrigerators = [];
    let existingInSalePoint = [];
    if (this.serialNumber) {
      try {
        existingRefrigerators = await this.commonService.getSimpleList(`refrigerator/search?filter=serial_number=${this.serialNumber}`) as [];
        if (existingRefrigerators.length > 0) {
          // existingRefrigerators = await this.commonService.getSimpleList(`refrigerator?filter=serial_number=${this.serialNumber} AND NOT(phase_id = 5 OR (phase_id = 1 AND active_repairs <2))`) as [];
          if (existingRefrigerators[0].phase_id !== 5 && existingRefrigerators[0].phase_id !== 1) {
            this.openSnackBar('Το ψυγείο δεν μπορεί να συμμετέχει στην εντολή διότι συμμετέχει ήδη σε κάποια άλλη');
            this.serialNumberError = true;
            this.error = 'Το ψυγείο δεν μπορεί να συμμετέχει στην εντολή διότι συμμετέχει ήδη σε κάποια άλλη';
          } else if (existingRefrigerators[0].phase_id === 1 && existingRefrigerators[0].active_repairs >= 2) {
            this.openSnackBar('Το ψυγείο δεν μπορεί να συμμετέχει σε νέα εντολή, διότι βρίσκεται ήδη σε άλλη εντολή επισκευής');
            this.serialNumberError = true;
            this.error = 'Το ψυγείο δεν μπορεί να συμμετέχει στην εντολή διότι συμμετέχει ήδη σε κάποια άλλη';
          } else {
            existingInSalePoint = await this.commonService.getSimpleList(`refrigerator/refrigerator2?filter=serial_number=${this.serialNumber} AND (sale_point_id = ${salePointId} OR sale_point_id is null)`) as [];
            if (existingInSalePoint.length > 0) {
              this.serialNumberError = false;
            } else {
              this.openSnackBar('Το ψυγείο δεν μπορεί να συμμετέχει σε νέα εντολή, διότι δεν βρίσκεται στο επιλεγμένο σημείο αποστολής');
              this.serialNumberError = true;
              this.error = 'Το ψυγείο δεν μπορεί να συμμετέχει σε νέα εντολή, διότι δεν βρίσκεται στο επιλεγμένο σημείο αποστολής';
            }
          }
        } else {
          this.serialNumberError = false;
        }
      } catch (e) {
      } finally {
        this.validateSerialNumberLoading = false;
      }
    } else {
      this.validateSerialNumberLoading = false;
    }
  }

  refrigeratorSelectionChanged() {
    this.serialNumber = this.selectedRefrigerator.serial_number;
  }

  clearRefrigeratorField() {
    this.selectedRefrigerator = null;
    this.serialNumber = '';
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }

  showRefrigeratorSelectionDialog($event) {
    $event.stopPropagation();
    const dialog = this.matDialog.open(RefrigeratorSelectionDialogComponent, {
      data: {
        refrigerators: this.existingRefrigerators
      }
    });

    dialog.afterClosed().subscribe(refrigerator => {
      if (refrigerator) {
        this.serialNumber = refrigerator.serial_number;
        this.selectedRefrigerator = this.existingRefrigerators.find(r => r.id === refrigerator.id);
      }
    });
  }
}
